module.exports = __webpack_public_path__ + "img/ic_average_audit_score.0fad897a.svg";